module.exports = __webpack_public_path__ + "static/img/fingerpost_goods_3.9c5659b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_goods_3.jpg
// module id = v9Jt
// module chunks = 0